import React from "react";
import 'bootstrap-icons/font/bootstrap-icons.css';
const steps = [
  {
    number: "01",
    icon: "bi-file-earmark-text",
    title: "Submit Your Application",
    text: "Complete our quick and secure online form with your basic personal and financial details to get started.",
  },
  {
    number: "02",
    icon: "bi-person-check",
    title: "Verify Your Documents",
    text: "Upload the required documents for verification. Our team ensures a smooth and hassle-free review process.",
  },
  {
    number: "03",
    icon: "bi-search",
    title: "Eligibility & Credit Review",
    text: "We carefully evaluate your profile and creditworthiness to offer you the most suitable loan options.",
  },
  {
    number: "04",
    icon: "bi-people-fill",
    title: "Approval & Fund Transfer",
    text: "After approval, the loan amount is securely transferred to your bank account within 24–48 hours.",
  },
];

const SimpleProcess = () => {
  return (
    <section className="py-5 process-section">
      <div className="container text-center">
        <h2 className="fw-bold mb-3 process-title">Our Simple Process</h2>
        <p className="text-muted mb-5">
          Get your loan in just a few easy steps
        </p>

        <div className="row g-4">
          {steps.map((step, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="card border-0 shadow-sm h-100 process-card position-relative p-4">
                
                {/* Step Number */}
                <div className="step-number">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="mb-4 mt-4">
                  <i className={`bi ${step.icon} process-icon`}></i>
                </div>

                {/* Title */}
                <h5 className="fw-bold mb-3">{step.title}</h5>

                {/* Text */}
                <p className="text-muted small">{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SimpleProcess;